import React from 'react'

export default function Footer() {
    return (
        <div className='bg-dark text-light text-center p-2'>
            <h6>News Feed &copy 2019</h6>


        </div>
    )
}
